import React from 'react'

function TechnicalAnalysis() {
  return (
    <section class="wrapper custom-wrapper services-wrapper wh-text">
        <div class="container contact-container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="block-title">Technical Analysis</h2>
                    <p class="text-300">Analysis is the process of gathering and comparing information about the web and its operation and use in order to improve the web's overall quality and to identify problem areas. The proper  and complete or accurate analysis process, especially technical analysis leads to success. Technical Analysis is a key step to developing a software application.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <ul class="list-unstyled services-list hi-icon-effect-8">
                    <li>
                        <div class="service-icon hi-icon"><i class="ico-img ico-php"></i></div>
                        <div class="service-des">
                            <h3>PHP Webs Application</h3>
                            <p>PHP is a server side scripting language.It consuming server's resources and sends output to the client</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="ico-img ico-ms-sharepoint"></i></div>
                        <div class="service-des">
                            <h3>Microsoft Sharepoint</h3>
                            <p>Microsoft SharePoint is a browser-based collaboration and document management platform from Microsoft.</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="fa fa-shopping-cart"></i></div>
                        <div class="service-des">
                            <h3>E-Commerce website</h3>
                            <p>Electronic commerce, commonly written as e-commerce which trade products or services through the internet</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="fa fa-drupal"></i></div>
                        <div class="service-des">
                            <h3>Drupal</h3>
                            <p>It is free, open source. The application includes a content management platform and a development framework</p>
                        </div>
                    </li>
                    </ul>
                </div>
                <div class="col-sm-4">
                    <ul class="list-unstyled services-list hi-icon-effect-8">
                    <li>
                        <div class="service-icon hi-icon"><i class="fa fa-desktop"></i></div>
                        <div class="service-des">
                            <h3>ASP.NET Application</h3>
                            <p>It is an server-side web application, designed for web development to produce dynamic web pages</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="ico-img ico-jsp-app"></i></div>
                        <div class="service-des">
                            <h3>JSP Webs Application</h3>
                            <p>JSP is a server-side programming to enables the creation of dynamic platform to build application</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="fa fa-html5"></i></div>
                        <div class="service-des">
                            <h3>PSD to HTML5</h3>
                            <p>PSD to HTML is a workflow to design a page in a Photoshop Document and then converted to code using HTML, CSS</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="fa fa-android"></i></div>
                        <div class="service-des">
                            <h3>Android App Design</h3>
                            <p>It is the process by which new applications are created for the Android operating system using Java</p>
                        </div>
                    </li>
                    </ul>
                </div>
                <div class="col-sm-4">
                    <ul class="list-unstyled services-list hi-icon-effect-8">
                    <li>
                        <div class="service-icon hi-icon"><i class="ico-img ico-cms-app"></i></div>
                        <div class="service-des">
                            <h3>CMS Web Application</h3>
                            <p>CMS is a web application that provides capabilities for multiple users with different permission levels</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="fa fa-wordpress"></i></div>
                        <div class="service-des">
                            <h3>PSD to Wordpress</h3>
                            <p>We convert PSDs to responsive, SEO friendly & Crossbrowser compatible WordPress themes at affordable price</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="ico-img ico-responsive"></i></div>
                        <div class="service-des">
                            <h3>Responsive Design</h3>
                            <p>It is an approach that suggests the design should respond to all browsers based on screen size</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon"><i class="ico-img ico-bootstrap"></i></div>
                        <div class="service-des">
                            <h3>Bootstrap Theming</h3>
                            <p>It is the most popular HTML, CSS, and JavaScript framework for developing responsive, mobile-first web sites</p>
                        </div>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
  )
}

export default TechnicalAnalysis